// import SwapVertIcon from '@mui/icons-material/SwapVert';
import { Button, Typography } from '@mui/material';
import React from 'react';

interface JobQueueHeaderProps {
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAddJob: () => void;
  onSortClick: () => void;
}

const JobQueueHeader: React.FC<JobQueueHeaderProps> = ({
  onSearchChange,
  onAddJob,
  onSortClick,
}) => {
  const [searchValue, setSearchValue] = React.useState('');

  return (
    <div className="job-queue-header">
      {/* Search and Actions */}
      <div className="job-queue-actions">
        <Typography
          variant="h4"
          sx={{
            color: '#161719',
            fontFamily: 'Red Hat Display Bold',
            fontSize: '16px',
            fontWeight: 'semi-bold',
          }}>
          Job Queue
        </Typography>

        <div className="action-buttons">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value.trimStart());
                onSearchChange(e);
              }}
              className="job-queue-search"
            />
          </div>
          {/* <Button
            onClick={onSortClick}
            sx={{
              '&:hover': {
                backgroundColor: '#f9fafb',
              },
              backgroundColor: 'transparent',
              border: '1px solid #e5e7eb',
              borderRadius: '6px',
              color: 'black',
              marginRight: '8px',
              minWidth: 'auto',
              padding: '8px',
            }}>
            <SwapVertIcon
              sx={{
                fontSize: '15px',
              }}
            />
          </Button> */}

          <Button
            onClick={onAddJob}
            sx={{
              '&:hover': {
                backgroundColor: '#374151',
              },
              backgroundColor: '#161719',
              borderRadius: '6px',
              color: 'white',
              fontFamily: 'Inter',
              fontSize: '12px',
              fontWeight: 'medium',
              height: '32px',
              padding: '8px 16px',
              textTransform: 'none',
            }}>
            + Add Job
          </Button>
        </div>
      </div>
    </div>
  );
};

export default JobQueueHeader;
